import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=65f839c4&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=65f839c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f839c4",
  null
  
)

export default component.exports